import {type TFunction} from 'i18next';

export const idToNameMap = <T extends {id: string; name: string}>(entities: T[]) => {
  return new Map(entities.map<[string, string]>(({id, name}) => [id, name]));
};

export const idToEntityMap = <T extends {id: string}>(entities: T[]) => {
  return new Map(entities.map<[string, T]>((entity) => [entity.id, entity]));
};

export const keyToEntityMap = <T, K>(entities: T[], keyAccessor: (entity: T) => K) => {
  return new Map(entities.map<[K, T]>((entity) => [keyAccessor(entity), entity]));
};

export const enumToEntityMap = (entities: string[], t: TFunction) => {
  return new Map(entities.map<[string, string]>((entity) => [entity, t(entity)]));
};

export const groupEntityByKeyMap = <T, K>(entities: T[], keyAccessor: (entity: T) => K) => {
  const map = new Map<K, T[]>();
  entities.forEach((entity) => {
    const key = keyAccessor(entity);

    const group = map.get(key) ?? [];
    group.push(entity);
    map.set(key, group);
  });

  return map;
};
